<template>
    <section class="main promotions">
        <h1 class="dashboard"><span class="breadcrumb" @click="clearFilters()">Promotion Pack{{ $route.query.for ? ' ' + capitalizeFirstLetter($route.query.for) : 's'}}</span><i v-if="filters.push_pack_id" class="fas fa-chevron-right"></i>{{ push_pack_name }}</h1>

        <div class="filters" v-if="!filters.push_pack_id">
            <div class="two-columns selectors">
                <label>Description</label>
                <label>Status</label>
                <div class="input-with-control">
                    <input class="promotions" type="search" v-model="filters.search_text" placeholder="Search..." @search="setFilter('search_text')">
                    <div class="button promotions input-go" @click="setFilter('search_text')"><i class="fas fa-search"></i></div>
                </div>
                <div>
                    <select v-model="filters.published" class="promotions" style="max-width: 18em;" @change="setFilter('published')">
                        <option value="">Select...</option>
                        <option value="0">Published</option>
                        <option value="1">Not Published</option>
                    </select>
                </div>
            </div>
            <div>
                <router-link v-if="!isAdmin" to="/promotionpacks/new" tag="button" class="button promotions" style="float: right; margin: 0.75em 0 0 0;">New Promotion Pack</router-link>
            </div>
        </div>

        <div v-if="message" class="empty-list">
            {{ message }}
            <div v-if="loading" class="loading"><i class="fas fa-spinner fa-spin"></i></div>
        </div>

        <div v-if="!loading && !push_pack_id && pushPacks.length > 0" class="item-list">
            <div :class='["item-row-heading", { isadmin: isAdmin }]'>
                <label>Created</label>
                <label v-if="isAdmin">Dist</label>
                <label>Code</label>
                <label>Description</label>
                <label>Public On</label>
                <label>Order By</label>
                <label class="center">Marquees</label>
                <label class="center">Features</label>
                <label class="center">Email</label>
                <label class="center">Published</label>
                <label class="center">Locked</label>
                <label class="center">Scheduled</label>
            </div>
            <div v-for="(pushPack, index) in pushPacks" :key="index" :class="['item-row', { isadmin: isAdmin }]" @click="loadItem(pushPack.push_pack_id)">
                <span>{{ pushPack.date_created }}</span>
                <span v-if="isAdmin">{{ pushPack.distributor_code}}</span>
                <span>{{ pushPack.push_pack_code }}</span>
                <span>{{ pushPack.description }}</span>
                <span>{{ pushPack.start_date }}</span>
                <span>{{ pushPack.order_end_date }}</span>
                <span class="center" v-html="pushPack.marquees ? '&#10004;' : '' "></span>
                <span class="center" v-html="pushPack.features ? '&#10004;' : '' "></span>
                <span class="center" v-html="pushPack.email ? '&#10004;' : '' "></span>
                <span class="center" v-html="pushPack.internal_use_only == 1 ? '' : '&#10004;' "></span>
                <span class="center" v-html="pushPack.locked == 1 ? '&#10004;' : '' "></span>
                <span class="center">{{ pushPack.schedule_date }}</span>
            </div>
        </div>

        <pagination v-if="showPagination" :paging="paging" @updatePage="goToPage"></pagination>

        <div v-if="!loading && push_pack_id">
            <div class="main-form">
                <div>
                    <div class="three-columns">
                        <div style="grid-column: 1 / 3">
                            <label>Description</label>
                            <input class="promotions" type="text" v-model="detail.description" required="required" :readonly="noEdit">
                        </div>
                        <div>
                            <label>Code</label>
                            <input class="promotions" type="text" v-model="detail.push_pack_code" required="required" :readonly="noEdit">
                        </div>
                    </div>
                    <div class="three-columns">
                        <div>
                            <label>Dealer Order Start Date</label>
                            <input class="promotions" type="date" v-model="detail.order_start_date" required="required" :readonly="noEdit">
                        </div>
                        <div>
                            <label>Dealer Order End Date</label>
                            <input class="promotions" type="date" v-model="detail.order_end_date" required="required" :readonly="noEdit">
                        </div>
                        <div>
                        </div>
                    </div>
                    <div class="three-columns">
                        <div>
                            <label>Public Start Date</label>
                            <input class="promotions" type="date" v-model="detail.start_date" required="required" :readonly="noEdit">
                        </div>
                        <div>
                            <label>Public End Date</label>
                            <input class="promotions" type="date" v-model="detail.end_date" required="required" :readonly="noEdit">
                        </div>
                        <div>
                            <label>Published</label>
                            <div>
                                <label class="radio">
                                    <input type="radio" v-model="detail.internal_use_only" value="0" :disabled="noEdit">
                                    <span :class="noEdit ? 'disabled' : 'promotions'"><i class="fas fa-check-circle"></i>Yes</span>
                                </label>
                                <label class="radio">
                                    <input type="radio" v-model="detail.internal_use_only" value="1" :disabled="noEdit">
                                    <span :class="noEdit ? 'disabled' : 'promotions'"><i class="fas fa-check-circle"></i>No</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="margin: 0 2em;">
                    <div class="two-columns" style="margin: 1.45em 0 0.5em 0;">
                        <div>
                            <div :class="['button', noEdit ? 'disabled' : 'promotions']" @click="saveDetail()">Save</div>
                        </div>
                        <div>
                            <router-link to="/promotionpacks" tag="div" class="button cancel">Cancel</router-link>
                        </div>
                    </div>
                    <label v-if="saveMessage">{{ saveMessage }}<span v-if="saving"> &nbsp;<i class="fas fa-spinner fa-spin"></i></span></label>
                    <div v-if="isAdmin" style="margin: 2em 0 0 0;">
                        <h2>Administrators Only</h2>
                        <div class="two-columns">
                            <div>
                                <div :class="['button', saving ? 'disabled' : 'promotions']" @click="lockPromoPack()">{{ detail.locked ? 'Unlock' : 'Lock' }} Promo Pack</div>
                            </div>
                            <label>
                                Locking prevents the Distributor from making further changes.
                            </label>
                        </div>
                    </div>
                    <div v-else-if="detail.locked" style="margin: 2em 0 0 0;">
                        <i class="fas fa-lock"></i> This promo pack is locked
                    </div>
                </div>
            </div>

            <div class="form-section">
                <div :class="['button', push_pack_id == 'new' || noEdit ? 'disabled' : 'promotions' ]" @click="manageSection('marquees')"><i class="fas fa-edit"></i></div>
                <h2>Marquees</h2>
                <div v-if="marquees.length == 0" class="empty-list">No marquees</div>
                <div v-else class="form-section-grid marquees">
                    <div v-for="(marquee, index) in marquees" :key="index" class="form-grid-item">
                        <img :src="marquee.image_src" class="marquee">
                        <div class="caption">
                            <div style="float: right;"><b>{{ marquee.upc }}</b></div>
                            <div><b>{{ marquee.item_number }}</b></div>
                             {{ marquee.description }}
                         </div>
                         <div class="caption" style="margin: 1em 0 0 0;">
                             <div v-if="marquee.price" style="float: right;"><label>Retail&nbsp;</label><b>${{ marquee.price }}</b></div>
                             <div v-if="marquee.cost"><label>Price&nbsp;</label><b>${{ marquee.cost }}</b></div>
                         </div>
                    </div>
                </div>
            </div>

            <div class="form-section">
                <div :class="['button', push_pack_id == 'new' || noEdit ? 'disabled' : 'promotions' ]" @click="manageSection('products')"><i class="fas fa-edit"></i></div>
                <h2>Featured Products</h2>
                <div v-if="products.length == 0" class="empty-list">No featured products</div>
                <div v-else class="form-section-grid products">
                    <div v-for="(product, index) in products" :key="index" class="form-grid-item">
                        <img v-if="product.display_flag > 0" :src="'/img/sale-badge-' + product.display_flag + '.png'" class="display-flag">
                        <div style="text-align: center;">
                            <img :src="product.image_src" class="product">
                        </div>
                        <div class="caption">
                            <div style="float: right;"><b>{{ product.upc }}</b></div>
                            <div><b>{{ product.item_number }}</b></div>
                            {{ product.description }}
                        </div>
                        <div class="caption" style="margin: 1em 0 0 0;">
                            <div v-if="product.price" style="float: right;"><label>Retail&nbsp;</label><b>${{ product.price }}</b></div>
                            <div v-if="product.cost"><label>Price&nbsp;</label><b>${{ product.cost }}</b></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-section" v-if="isAdmin">
                <!-- <div :class="['button', push_pack_id == 'new' || noEdit ? 'disabled' : 'promotions' ]" @click="manageSection('email')"><i class="fas fa-edit"></i></div> -->
                <div class="two-columns">
                    <div class="email-section">
                        <h2>Exclude Dealers</h2>
                        <div class="input-with-control">
                            <input class="promotions" type="search" v-model="dealer_search_text" placeholder="Search for dealers to exclude..." @search="searchDealers()">
                            <div class="button promotions input-go" @click="searchDealers()" style="font-size: 1.2em; width: 2em;"><i class="fas fa-search"></i></div>
                        </div>
                        <div v-if="dealerSearchMessage">{{ dealerSearchMessage }}</div>
                        <div v-if="dealerSerchList.length > 0" class="dealer-search-results">
                            <label>Search results...</label>
                            <div v-for="(dealer, index) in dealerSerchList" class="dealer-row">
                                <div>{{ dealer.company_name }}</div>
                                <div>{{ dealer.address_1 }}</div>
                                <div>{{ dealer.city }}</div>
                                <div>{{ dealer.state }}</div>
                                <div>{{ dealer.zip_code }}</div>
                                <div>
                                    <div class="button promotions" @click="addDealerExclude(index)">+</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="dealerExcludeList.length > 0" class="dealer-search-results">
                            <label>Excluded dealers...</label>
                            <div v-for="(dealer, index) in dealerExcludeList" class="dealer-row">
                                <div>{{ dealer.company_name }}</div>
                                <div>{{ dealer.address_1 }}</div>
                                <div>{{ dealer.city }}</div>
                                <div>{{ dealer.state }}</div>
                                <div>{{ dealer.zip_code }}</div>
                                <div>
                                    <div class="button promotions" @click="removeDealerExclude(index)">x</div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="button promotions" style="float: none; display: inline-block; margin: 0.5em 0 0 0;" @click="saveExcludedDealers()">Save Excluded Dealers</div>
                        </div>
                    </div>
                    <div>
                        <h2>Email</h2>
                        <div style="margin: 0 0 2em 0;">
                            <label>Subject</label>
                            <input type="text" v-model="email.subject" />
                            <label>Preview Text</label>
                            <input type="text" v-model="email.subhead" />
                            <div :class="['button', saving ? 'disabled' : 'promotions']" style="float: none;" @click="saveEmail()">Save Email</div>
                            <label v-if="emailSaveMessage" style="margin: 1em 0 0 0;">{{ emailSaveMessage }}<span v-if="saving"> &nbsp;<i class="fas fa-spinner fa-spin"></i></span></label>
                        </div>
                        <div class="two-columns" style="margin: 0 0 2em 0;">
                            <div :class="['button', testing ? 'disabled' : 'promotions']" style="float: none;" @click="testEmail()">Test Email</div>
                            <label>Generate a test email.</label>
                            <label v-if="testMessage" style="margin: 1em 0 0 0;">{{ testMessage }}<span v-if="testing"> &nbsp;<i class="fas fa-spinner fa-spin"></i></span></label>
                        </div>
                        <div class="two-columns" style="margin: 0 0 2em 0;">
                            <div>
                                <label>Schedule Email</label>
                                <input class="promotions" type="date" v-model="email.schedule_date">
                                <div :class="['button', notSchedulable ? 'disabled' : 'promotions']" style="float: none;" @click="scheduleEmail()">Schedule Email</div>
                            </div>
                            <label style="margin: 1.5em 0 0 0;">
                                Schedule a live email.<br>Promo Pack must be Locked, Published with a future End Date and have an Email that you have tested.
                            </label>
                        </div>
                        <label v-if="scheduleMessage" style="margin: 1em 0 0 0;">{{ scheduleMessage }}<span v-if="scheduling"> &nbsp;<i class="fas fa-spinner fa-spin"></i></span></label>
                    </div>
                </div>

            </div>
        </div>

	</section>

</template>

<script>
export default {
	name: 'promotions',
    props: ['push_pack_id'],
	data() {
        return {
            loading: true,
            message: '',
            filters: {
                section: 'promotions',
                start_date: this.getTodaysDate(),
                push_pack_id: '',
                search_text: '',
                published: ''
            },
            paging: {},
            marqueeSearchList: [],
            marqueeSearchMessage: '',
            pushPacks: [],
            push_pack_name: '',
            detail: {},
            marquees: [],
            products: [],
            email: {},
            saving: false,
            saveMessage: '',
            testing: '',
            testMessage: '',
            scheduling: false,
            scheduleMessage: '',
            displayFlags: {
    			0: {'label': '', 'color': "#fff;"},
    			1: {'label': 'Sale', 'color': "#C71D22;"},
    			2: {'label': 'Temporary Price Reduction', 'color': "#F8B100;"},
    			3: {'label': 'Temporary Lower Cost', 'color': "#00CE22;"},
    			4: {'label': 'Free Shipping', 'color': "#0061E0;"},
    			5: {'label': 'Shop In-Store For Lowest Prices', 'color': "#DF8605;"},
    			6: {'label': 'Closeout', 'color': "#27C344;"}
    		},
            searching: false,
            dealer_search_text: '',
            dealerSerchList: [],
            dealerExcludeList: [],
            dealerSearchMessage: '',
            dealerExcludeSaveMessage: '',
            emailSaveMessage: ''
        }
    },
    created() {
        // any filters previously stored for this section?
        if (this.getFilters.section == 'promotions') {
            this.filters = this.getFilters // filters were stored last time we hit fetchDataItems()
        }
        if (this.push_pack_id) {
            this.filters.push_pack_id = this.push_pack_id
            this.fetchDetail()
        } else {
            this.filters.push_pack_id = ''
            this.fetchList()
        }
    },
    computed: {
        showPagination() {
            return this.pushPacks.length > 0 && this.paging.total_pages > 1
        },
        isAdmin() {
            return this.getUser.user_type_code.indexOf('ADMIN') > -1
        },
        notSchedulable() {
            return this.scheduling || this.detail.internal_use_only == 1 || this.detail.locked != 1|| this.getTodaysDate() > this.detail.end_date || !this.email.push_pack_id || !this.email.test_date || !this.email.schedule_date || this.getTodaysDate() >= this.email.schedule_date
        },
        noEdit() {
            return !this.isAdmin && (this.detail.locked || this.saving)
        }
    },
    methods: {
        fetchList() {
            this.pushPacks = []
            this.loading = true
            this.message = 'Loading'
            this.apiCall({ destination: 'get_list_push_packs', data: this.filters }).then(obj => {
                this.loading = false
                this.message = obj.message
                if (obj.status == 'success') {
                    this.storeFilters(this.filters) // store current filter set
                    this.pushPacks = obj.push_packs
                    if (this.pushPacks.length < 1) {
                        this.message = 'No promotion packs found'
                    }
                    this.paging = obj.paging
                    window.scrollTo(0,0);
                }
            })
        },
        goToPage(page) {
			this.paging.current_page = page
			this.setFilter('page')
		},
        setFilter(which) {
            switch (which) {
                case 'page':
                    this.filters.page = this.paging.current_page
                    this.fetchList()
                    return false;
                case 'published':
                    this.filters.page = 1
                    this.fetchList()
                    return false;
                case 'marquee':
                    this.marqueeSearchList = []
                    this.marqueeSearchMessage = ''
                    this.searchFilter('marquee')
                    return false
                case 'product_description':
                    this.fetchList()
                    return false
                case 'search_text':
                    this.fetchList()
                    return false
                case 'dates':
                    this.fetchList()
                    return false
            }
        },
        searchFilter(which) {
            this.filters.filter_by_list = which
            this.apiCall({ destination: 'get_filter_list', data: this.filters }).then(obj => {
                if (obj.status == 'success') {
                    if (obj.filter_list.length == 1) {
                        this.filters.manufacturer_name = obj.filter_list[0]['description']
                        this.filters.manufacturer_id = obj.filter_list[0]['manufacturer_id']
                        this.fetchItems()
                    } else if (obj.filter_list.length > 1) {
                        this.manufacturerSearchList = obj.filter_list
                    } else {
                        this.manufactuerSearchMessage = 'Marquee not found'
                    }
                } else {
                    this.message = obj.message
                }
            })
        },
        setFilterFromSearch(data) {
            if (this.filters.filter_by_list == 'marquee') {
                this.marqueeSearchList = []
                this.marqueeSearchMessage = ''
                this.filters.marquee_name = data.description
                this.filters.marquee_id = data['marquee_id']
            }
            this.message = ''
            this.fetchItems()
        },
        clearFilters() {
            this.filters = {
                section: 'promotions',
                start_date: this.getYearStartDate(),
                end_date: this.getTodaysDate(),
                push_pack_id: '',
                search_text: '',
                location_id: '',
                location_name: '',
                filter_by_list: '',
                marquee_id: '',
                marquee_name: ''
            }
            this.detail = {}
            this.push_pack_name = ''
            this.message = ''
            if (this.$route.path != '/promotionpacks') {
                // pushing route will clear id
                this.$router.push('/promotionpacks')
            } else {
                // but if base route already, reload data
                this.fetchList()
            }
        },
        loadItem(pushPackId) {
            switch (this.$route.query.for) {
                case 'marquees':
                    this.$router.push('/marquees/' + pushPackId)
                    break;
                case 'products':
                    this.$router.push('/products/' + pushPackId)
                    break;
                case 'email':
                    this.$router.push('/email/' + pushPackId)
                    break;
                default:
                    this.$router.push('/promotionpacks/' + pushPackId)
                    break;
            }
        },
        fetchDetail() {
            if (this.push_pack_id == 'new') {
                this.resetDetail()
                this.push_pack_name = 'New'
                this.loading = false
            } else {
                this.loading = true
                this.message = 'Loading'
                this.apiCall({ destination: 'get_item_push_pack', data: { push_pack_id: this.push_pack_id } }).then(obj => {
                    this.loading = false
                    this.message = obj.message
                    if (obj.status == 'success') {
                        this.detail = obj.push_pack
                        this.push_pack_name = this.detail.description
                        this.apiCall({ destination: 'get_list_push_pack_marquees', data: { push_pack_id: this.push_pack_id } }).then(obj => {
                            this.marquees = obj.marquees
                        })
                        this.apiCall({ destination: 'get_list_push_pack_products', data: { push_pack_id: this.push_pack_id } }).then(obj => {
                            this.products = obj.products
                        })
                        this.apiCall({ destination: 'get_item_push_pack_email', data: { push_pack_id: this.push_pack_id } }).then(obj => {
                            if (obj.email.push_pack_id) {
                                this.email = obj.email
                            } else {
                                this.email = {
                                    push_pack_id: this.push_pack_id
                                }
                            }
                            this.dealerExcludeList = obj.excluded_dealers
                        })
                    }
                })
            }
        },
        resetDetail() {
            this.detail = {
                push_pack_id: this.push_pack_id,
                description: '',
                start_date: '',
                end_date: '',
                internal_use_only: 1,
                inactive: 0,
            }
            this.push_pack_name = ''
            this.marquees = []
            this.features = []
            this.email = []
        },
        saveDetail() {
            if (this.saving || this.noEdit) { return }
            if (!this.detail.description || !this.detail.push_pack_code) {
                this.saveMessage = 'Description and code are required.'
                setTimeout(() => { this.saveMessage = '' }, 2000)
                return
            }
            if (!this.detail.order_start_date || !this.detail.order_end_date) {
                this.saveMessage = 'Dealer order start date and end date are required.'
                setTimeout(() => { this.saveMessage = '' }, 2000)
                return
            }
            if (!this.detail.start_date || !this.detail.end_date) {
                this.saveMessage = 'Publish start date and end date are required.'
                setTimeout(() => { this.saveMessage = '' }, 2000)
                return
            }
            this.saving = true
            this.saveMessage = 'Saving'
            this.apiCall({ destination: 'save_item_push_pack', data: this.detail }).then(obj => {
                this.saving = false
                this.saveMessage = obj.message
                if (obj.status == 'error') {
                    setTimeout(() => { this.saveMessage = '' }, 2000)
                } else {
                    this.detail.push_pack_code = obj.push_pack_code
                    if (this.push_pack_id == 'new') {
                        var pushPackId = obj.push_pack_id
                        setTimeout(() => { this.$router.push({ path: `/promotionpacks/${pushPackId}`}) }, 2000)
                    } else {
                        setTimeout(() => { this.saveMessage = '' }, 2000)
                    }
                }
            })
        },
        manageSection(which) {
            if (!this.push_pack_id || this.push_pack_id == 'new' || this.noEdit) { return }
            this.$router.push('/' + which + '/' + this.push_pack_id)
        },
        lockPromoPack() {
            this.saving = true
            this.saveMessage = 'Locking'
            this.apiCall({ destination: 'save_item_push_pack_lock', data: { push_pack_id: this.detail.push_pack_id, locked: !this.detail.locked } }).then(obj => {
                this.saving = false
                this.saveMessage = obj.message
                this.detail.locked = !this.detail.locked
            })
        },
        saveEmail() {
            this.saving = true
            this.emailSaveMessage = 'Saving'
            this.apiCall({ destination: 'save_item_push_pack_email', data: this.email }).then(obj => {
                this.saving = false
                this.emailSaveMessage = obj.message
            })
        },
        testEmail() {
            this.testing = true
            this.testMessage = 'Testing'
            this.apiCall({ destination: 'save_item_push_pack_email_test', data: { push_pack_id: this.detail.push_pack_id } }).then(obj => {
                this.testing = false
                this.testMessage = obj.message
            })
        },
        scheduleEmail() {
            if (this.scheduling || this.notSchedulable) { return }
            this.scheduling = true
            this.scheduleMessage = 'Scheduling...'
            this.apiCall({ destination: 'save_item_push_pack_schedule', data: { push_pack_id: this.detail.push_pack_id, email_date: this.email.schedule_date } }).then(obj => {
                this.scheduling = false
                this.scheduleMessage = obj.message
            })
        },
        searchDealers() {
            this.dealerSearchMessage = ''
            this.dealerSerchList = []
            if (this.searching || !this.dealer_search_text) { return }
            this.searching = true
            this.apiCall({ destination: 'get_list_dealers_by_search', data: { push_pack_id: this.detail.push_pack_id, search_text: this.dealer_search_text } }).then(obj => {
                this.searching = false
                this.dealerSearchMessage = obj.message
                if (obj.clients.length == 1) {
                    this.dealerExcludeList.push(obj.clients[0])
                    this.dealer_search_text = ''
                } else if (obj.clients.length > 1) {
                    this.dealerSerchList = obj.clients
                }
            })
        },
        addDealerExclude(index) {
            let dealer = JSON.parse(JSON.stringify(this.dealerSerchList[index]))
            this.dealerExcludeList.push(dealer)
            this.dealerSerchList.splice(index, 1)
        },
        removeDealerExclude(index) {
            this.dealerExcludeList.splice(index, 1)
        },
        saveExcludedDealers() {
            if (this.saving) { return }
            this.dealerExcludeSaveMessage = ''
            this.apiCall({ destination: 'save_dealer_exclude_list', data: { push_pack_id: this.detail.push_pack_id, dealer_list: this.dealerExcludeList } }).then(obj => {
                this.saving = false
                this.dealerExcludeSaveMessage = obj.message
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.item-row, .item-row-heading {
    grid-template-columns: 1fr 2fr 4fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    &.isadmin {
        grid-template-columns: 1fr 5em 2fr 4fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    }
    .center { text-align: center; }
}
.dealer-search-results {
    border: 1px solid #ccc;
    padding: 0.5em 0.5em 0.25em 0.5em;
    .dealer-row {
        margin: 0.25em 0;
        display: grid;
        grid-template-columns: 1.5fr 1fr 1fr 3em 5em 1em;
    }
}
</style>
